import InlineEditors from '../../../controllers/inlineEditors';
import getDefaultCell from './getDefaultCell';
import { getBaselineTemplate, getDefaultTemplateWithTooltip } from '../helpers';

export default function (data) {
  const isEditDisable = InlineEditors.checkByLinkDependency(data.task, data.column.name);

  if (isEditDisable) {
    const baselineTemplate = data.isBaseline ? getBaselineTemplate(data.baselineValue) : '';
    const tooltipKey = data.task.type === data.instance.config.types.project
      ? 'why_can_not_set_it_case2_start'
      : 'why_can_not_set_it_case4';

    return `${getDefaultTemplateWithTooltip(data.cellValue, tooltipKey)}${baselineTemplate}`;
  }

  return getDefaultCell(data);
}
